// Colour
import { emeraldGreen } from "Constants/ColourConstants";

export const styles = {
  searchGrid: {
    p: 2,
    width: { xs: "90%", md: "70%" },
    alignItems: "center",
    justifyContent: "space-between",
  },
  loading: {
    marginTop: "5%",
    color: emeraldGreen,
  },
};
